var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "banner",
      class: [{ on: _vm.componentContent.categoryShow }]
    },
    [
      _c(
        "el-carousel",
        _vm._l(_vm.bannerList, function(item, index) {
          return _c(
            "el-carousel-item",
            {
              key: index,
              style: {
                backgroundImage: "url(" + item.bannerUrl + ")",
                backgroundSize: "cover"
              }
            },
            [
              _c(
                "a",
                {
                  staticClass: "a-link",
                  on: {
                    click: function($event) {
                      return _vm.jumpLink(item.linkObj)
                    }
                  }
                },
                [
                  _c("img", {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: item.bannerUrl,
                        expression: "item.bannerUrl"
                      }
                    ],
                    staticClass: "img",
                    attrs: { src: item.bannerUrl }
                  })
                ]
              )
            ]
          )
        }),
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-loader/node_modules/vue-hot-reload-api")      .rerender("data-v-dc4a5cac", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/_vue-loader@13.7.3@vue-loader/lib/template-compiler?{"id":"data-v-dc4a5cac","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=template&index=0!./src/components/canvasShow/cereshop/pc_b2c/banner.vue
// module id = null
// module chunks = 